<template>
    <div id="performance">
        <v-alert dense border="bottom" type="primary" icon="mdi-information">
            PERFORMANCE
        </v-alert>
        <v-card-text>
            <v-container>
                <v-row> </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>
<script>
import axios from "axios"

export default {
    props: ["detailcase"],
    data() {
        return {}
    },
}
</script>
